import {  Drawer } from "antd";


export default function WallVisitPanel({
  isVisible,
  station,
  setVisible,
}: any) {


  return (
    <Drawer
      placement={"right"}
      width={700}
      onClose={() => setVisible(false)}
      visible={isVisible}
      closable={false}
      mask={false}
      bodyStyle={{padding: "15px", backgroundColor: "#E50000"}}

    >
      <div className="col-span-12 sm:col-span-12 md:col-span-12 bg-toyota flex flex-col justify-start ">
        <div className="text-3xl px-2  border-gray-100 w-full text-black  mb-2 text-center flex justify-between items-center bg-white">
          <div className="truncate uppercase font-bold">{station?.name}</div>
          <div className="border-l border-toyota text-black font-bold py-3 text-3xl w-20">
            {station?.data?.length}
          </div>
        </div>
        <div className="">        
        <div className="grid grid-cols-12 gap-x-2 gap-y-2  bg-toyota pb-2">
          {station?.data?.map((visit: any, index: number) => (
            <div className="col-span-6 sm:col-span-6 md:col-span-6 bg-gray-100 border" key={index}>
              <div className="mx-2 bg-gray-100 py-3 text-gray-800 font-bold text-2xl text-left truncate">
                {visit?.vehicle?.registration}
              </div>
            </div>
          ))}
        </div>
          </div>
      </div>
    </Drawer>
  );
}
